package pl.decks.personal.pages.ievp.foreword

enum class Foreword {
    POST_HOG,
    TRIGGER_DEV,
    ICEYE,
    BIOPTIMUS,
    ZAPIER,
    MIX_RANK,
    TINY_PHARMA,
    ATRIA,
    ;
}
